Object.defineProperty(exports, "__esModule", { value: true });
exports.constants = void 0;
exports.constants = {
  EMAIL: "moonrestaurant.altdorf@gmail.com",
  PHONE_PRIMARY: "+49 8711421647",
  OWNER_NUMBER: "+49 15259755510",
};
